<template>
	<div class="card">
		<div class="card-body">
			<div class="row align-items-center">
				<div class="col-md-2 col-6">
					<base-input label="วันที่">
						<flat-picker class="form-control datepicker" v-model="startDate" />
					</base-input>
				</div>
				<div class="col-md-2 col-6">
					<base-input label="ถึง">
						<flat-picker class="form-control datepicker" v-model="endDate" />
					</base-input>
				</div>
				<div class="col-md-8 col-12 search">
					<base-button type="default" @click="submitSearch()" :disabled="loading">
						ค้นหา
					</base-button>
				</div>
			</div>

			<div class="row mt-4">
				<div class="col-md-8">
					<cashback-report-panel :data="transactions" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import flatPicker from 'vue-flatpickr-component'
import BonusSummaryPanel from '../backend-components/Summary/BonusSummaryPanel'
import CashbackReportPanel from '../backend-components/Summary/CashbackReportPanel'

import moment from 'moment'
import SummaryService from '../services/summary.service'

export default {
	components: {
		flatPicker,
		CashbackReportPanel,
	},
	data() {
		return {
			startDate: moment().format('YYYY-MM-DD'),
			endDate: moment().format('YYYY-MM-DD'),

			loading: false,
			transactions: [],
		}
	},
	methods: {
		async submitSearch() {
			this.loading = true
			try {
				const res = await SummaryService.summaryCashback({
					start: this.startDate,
					end: this.endDate,
				})
				this.transactions = res
			} catch ({ message }) {
				this.$notify({ type: 'danger', message })
			} finally {
				this.loading = false
			}
		},
	},
	created() {
		this.submitSearch()
	},
}
</script>
